import { Link } from 'react-router';
import { Home, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export default function NotFound() {
  return (
    <div className='flex min-h-screen items-center justify-center p-4'>
      <Card className='w-full max-w-md'>
        <CardHeader className='text-center'>
          <div className='mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-muted'>
            <span className='text-4xl font-bold text-muted-foreground'>404</span>
          </div>
          <CardTitle className='text-2xl'>Page Not Found</CardTitle>
          <CardDescription>
            Sorry, we couldn't find the page you're looking for. It might have been removed, renamed, or doesn't exist.
          </CardDescription>
        </CardHeader>
        <CardContent className='flex flex-col gap-3'>
          <Button asChild className='w-full'>
            <Link to='/'>
              <Home className='mr-2 h-4 w-4' />
              Go to Dashboard
            </Link>
          </Button>
          <Button variant='outline' asChild className='w-full'>
            <Link to='..'>
              <ArrowLeft className='mr-2 h-4 w-4' />
              Go Back
            </Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

